/* import __COLOCATED_TEMPLATE__ from './address-with-validation.hbs'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _updateAddress, _validateAddress;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, computed } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { assertNonNullable } from '@banking/ui/utils/assert';
import { FieldIdentifier } from '@banking/ui/models/common/address';
import { GlobalAddress } from '@square/dashboard-protos/models/squareup/common/location';
import { inject as service } from '@ember/service';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
import { lgtmValidate } from '@banking/ui/utils/validator/lgtm-validate';
import globalAddressValidator from '@banking/ui/utils/validator/global-address-validator';
let AddressWithValidation = (_dec = computed('validation.errors.addressLine1.length'), _dec2 = computed('validation.errors.addressLine2.length'), _dec3 = computed('validation.errors.postalCode.length'), _dec4 = computed('validation.errors.administrativeDistrictLevel1.length'), _dec5 = computed('validation.errors.locality.length'), _class = (_updateAddress = /*#__PURE__*/new WeakSet(), _validateAddress = /*#__PURE__*/new WeakSet(), class AddressWithValidation extends Component {
  constructor(...args) {
    super(...args);
    _classPrivateMethodInitSpec(this, _validateAddress);
    _classPrivateMethodInitSpec(this, _updateAddress);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "_address", _descriptor2, this);
    _initializerDefineProperty(this, "validation", _descriptor3, this);
    _initializerDefineProperty(this, "liveValidate", _descriptor4, this);
    // "static" properties
    _defineProperty(this, "FieldIdentifier", FieldIdentifier);
  }
  get addressLineOneErrorMessage() {
    return this.validation.errors.addressLine1.length > 0 ? this.validation.errors.addressLine1[0] : undefined;
  }
  get addressLineTwoErrorMessage() {
    return this.validation.errors.addressLine2.length > 0 ? this.validation.errors.addressLine2[0] : undefined;
  }
  get postalCodeErrorMessage() {
    return this.validation.errors.postalCode.length > 0 ? this.validation.errors.postalCode[0] : undefined;
  }
  get administrativeAreaErrorMessage() {
    return this.validation.errors.administrativeDistrictLevel1?.length > 0 ? this.validation.errors.administrativeDistrictLevel1[0] : undefined;
  }
  get localityErrorMessage() {
    return this.validation.errors.locality.length > 0 ? this.validation.errors.locality[0] : undefined;
  }
  async onValueChange(field, value) {
    this._address = _classPrivateMethodGet(this, _updateAddress, _updateAddress2).call(this, this._address, field, value);
    if (this.liveValidate) {
      this.validation = await _classPrivateMethodGet(this, _validateAddress, _validateAddress2).call(this, this._address);
    }
    this.args.onValueChange(this._address);
  }
  async onClick() {
    this.liveValidate = true;
    this.validation = await _classPrivateMethodGet(this, _validateAddress, _validateAddress2).call(this, this._address);
    this.args.onClick(this._address, this.validation.valid);
  }

  /**
   * Provides parent component access to this component's onClick method
   * Allows external buttons (for example, market-header CTAs) to trigger address validation and submission
   */
  onDidInsert() {
    this.args.onDidInsert?.({
      onClick: this.onClick.bind(this)
    });
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_address", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.address;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "validation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      errors: {
        addressLine1: [],
        addressLine2: [],
        administrativeDistrictLevel1: [],
        locality: [],
        postalCode: []
      },
      valid: true
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "liveValidate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "addressLineOneErrorMessage", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "addressLineOneErrorMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addressLineTwoErrorMessage", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "addressLineTwoErrorMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "postalCodeErrorMessage", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "postalCodeErrorMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "administrativeAreaErrorMessage", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "administrativeAreaErrorMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "localityErrorMessage", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "localityErrorMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onValueChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onValueChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDidInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDidInsert"), _class.prototype), _class);
function _updateAddress2(address, field, value) {
  const addressRecord = address.toJSON();
  switch (field) {
    case FieldIdentifier.ADDRESS_LINE_1:
      {
        addressRecord.addressLine1 = value;
        break;
      }
    case FieldIdentifier.ADDRESS_LINE_2:
      {
        addressRecord.addressLine2 = value;
        break;
      }
    case FieldIdentifier.POSTAL_CODE:
      {
        addressRecord.postalCode = value;
        break;
      }
    case FieldIdentifier.ADMINISTRATIVE_AREA:
      {
        addressRecord.administrativeDistrictLevel1 = value;
        break;
      }
    case FieldIdentifier.LOCALITY:
      {
        addressRecord.locality = value;
        break;
      }
  }
  return GlobalAddress.fromObject(addressRecord);
}
function _validateAddress2(address) {
  const countryCode = assertNonNullable(this.args.countryAddressData.countryCode);
  const validator = lgtmValidate(globalAddressValidator(Country[countryCode], key => this.intl.t(key), true));
  return validator(address);
}
export { AddressWithValidation as default };